import React, { useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';
import MainLayout from './MainLayout';
import CommandPalette from '../../components/command-palette/CommandPalette';
import { useCommandPalette } from '../../components/command-palette/useCommandPalette';
// ----------------------------------------------------------------------


const StyledRoot = styled('div')({
    display: 'flex',
    minHeight: '100%',
    overflow: 'hidden',
});


// ----------------------------------------------------------------------


export default function DashboardLayout() {
    const [open, setOpen] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const [headerActions, setHeaderActions] = useState(null);
    const palette = useCommandPalette();

    const outletCtx = useMemo(
        () => ({
            setHeaderActions: (node) => setHeaderActions(node),
            clearHeaderActions: () => setHeaderActions(null),
        }),
        []
    );
    // const [openPdf, setOpenPdf] = useState(false);
    //
    // const pdfPath = '/assets/pdf/test.pdf';
    // const closePdf = () => {
    //     setOpenPdf(false);
    // };

    return (
        <StyledRoot>
            <Header
                onOpenNav={() => setOpen(true)}
                actions={headerActions}
                collapsed={collapsed}
                onOpenCommandPalette={palette.toggle}
            />

            <CommandPalette open={palette.open} onClose={palette.close} />

            <Nav openNav={open} onCloseNav={() => setOpen(false)} onToggleCollapse={() => setCollapsed((prev) => !prev)}
                collapsed={collapsed} />

            <MainLayout>
                {/*<PDFViewer open={openPdf} pdfData={pdfPath} onClose={closePdf}/>*/}
                <Outlet context={outletCtx} />
            </MainLayout>
        </StyledRoot>
    );
}
